class AnimateSticky extends HTMLElement {
  constructor() {
    super();
    this.runSync = this.runSync.bind(this);
    this.triggerAddToCart = this.triggerAddToCart.bind(this);
    this.syncQuantityToMain = this.syncQuantityToMain.bind(this);
    this.syncQuantityToSticky = this.syncQuantityToSticky.bind(this);
  }

  connectedCallback() {
    this.classList.add('active');
    this.classList.remove('hidden');

    const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');

    if (mainForm) {
      const sectionIdInput = mainForm.querySelector('input[name="section-id"]');
      this.sectionId = sectionIdInput ? sectionIdInput.value : null;

      if (!this.sectionId) return;

      this.stickyPriceDiv = document.getElementById(`sticky-price-wrapper-${this.sectionId}`);
      this.mainAddToCartBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.stickyAddToCartBtn = document.getElementById(`StickyAddToCart-${this.sectionId}`);
      this.mainQtyInput = document.getElementById(`Quantity-${this.sectionId}`);
      this.stickyQtyInput = document.getElementById(`Quantity-Sticky-${this.sectionId}`);

      if (this.stickyAddToCartBtn) {
        this.stickyAddToCartBtn.addEventListener('click', this.triggerAddToCart);
      }

      if (this.stickyQtyInput && this.mainQtyInput) {
        this.stickyQtyInput.addEventListener('change', this.syncQuantityToMain);
        this.mainQtyInput.addEventListener('change', this.syncQuantityToSticky);
      }

      mainForm.addEventListener('change', this.runSync);

      const productContainer = document.getElementById(`ProductInfo-${this.sectionId}`) || document.body;

      this.observer = new MutationObserver(() => {
        this.runSync();
      });

      this.observer.observe(productContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-checked'],
      });

      this.runSync();
    }
  }

  disconnectedCallback() {
    if (this.stickyAddToCartBtn) this.stickyAddToCartBtn.removeEventListener('click', this.triggerAddToCart);
    if (this.stickyQtyInput) this.stickyQtyInput.removeEventListener('change', this.syncQuantityToMain);
    if (this.mainQtyInput) this.mainQtyInput.removeEventListener('change', this.syncQuantityToSticky);
    if (this.observer) this.observer.disconnect();
  }

  triggerAddToCart(e) {
    e.preventDefault();
    if (this.mainAddToCartBtn) {
      const btnSpan = this.mainAddToCartBtn.querySelector('span');
      if (btnSpan) {
        btnSpan.click();
      } else {
        this.mainAddToCartBtn.click();
      }
    }
  }

  syncQuantityToMain() {
    if (this.mainQtyInput && this.stickyQtyInput && this.mainQtyInput.value !== this.stickyQtyInput.value) {
      this.mainQtyInput.value = this.stickyQtyInput.value;
      this.mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  syncQuantityToSticky() {
    if (this.mainQtyInput && this.stickyQtyInput && this.stickyQtyInput.value !== this.mainQtyInput.value) {
      this.stickyQtyInput.value = this.mainQtyInput.value;
    }
  }

  runSync() {
    setTimeout(() => {
      if (!this.stickyPriceDiv) return;

      const productContainer = document.getElementById(`ProductInfo-${this.sectionId}`) || document;

      const activeOption = productContainer.querySelector(
        '.loop-widget-purchase-option-selected, .loop-widget-purchase-option[aria-checked="true"]',
      );

      if (activeOption) {
        const priceEl = activeOption.querySelector('.loop-widget-purchase-option-price');

        if (priceEl && priceEl.innerText.trim() !== '') {
          this.stickyPriceDiv.innerHTML = `<span class="price-item price-item--regular" style="font-weight: bold;">${priceEl.innerHTML}</span>`;
          return;
        }
      }

      const fallbackPriceEl = document.querySelector(
        `#price-${this.sectionId} .price-item--last, #price-${this.sectionId} .price-item--regular`,
      );

      if (fallbackPriceEl) {
        this.stickyPriceDiv.innerHTML = `<span class="price-item price-item--regular" style="font-weight: bold;">${fallbackPriceEl.innerHTML}</span>`;
      }
    }, 150);
  }
}

customElements.define('animate-sticky', AnimateSticky);
